module.exports = __webpack_public_path__ + "static/media/Timer.5ce73bf8.svg";